var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarteavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Design_Low"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Design_Top"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009DDC",
    d: "M58.6,52.5c-1.7-1.7-4.4-1.7-6.1,0l0,0c-7.3,7.3-19.6,6.8-26.3-1.5c-5.1-6.4-5.1-15.6,0-21.9 c6.7-8.4,19-8.9,26.3-1.5l0,0c1.7,1.7,4.4,1.7,6.1,0l10.1-10.1c10.4,13.2,10.4,32,0,45.2L58.6,52.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009DDC",
    d: "M61.5,67.6c0.6,0.6,0.5,1.5-0.2,2c-0.3,0.2-0.5,0.4-0.8,0.6l0,0l0,0c-0.1,0.1-0.2,0.2-0.4,0.3l0,0 l0,0c-1.2,0.8-2.6,1.6-3.9,2.2l0,0l0,0c-0.2,0.1-0.5,0.2-0.8,0.4l-0.3,0.1c-0.4,0.2-0.7,0.3-1,0.4l0,0l0,0 c-6.4,2.7-13.4,3.5-20.2,2.3c-0.5-0.1-1.1-0.2-1.7-0.3c-0.6-0.1-1.1-0.3-1.7-0.4c-0.6-0.2-1.2-0.3-1.7-0.5 c-0.5-0.2-1.1-0.4-1.7-0.6c-0.6-0.2-1.1-0.5-1.6-0.7L25,73.3c-0.4-0.2-0.8-0.4-1.2-0.6c-0.3-0.1-0.5-0.3-0.8-0.4 c-0.8-0.4-1.6-0.9-2.3-1.3c-2.3-1.5-4.5-3.2-6.5-5.2c-14.3-14.3-14.3-37.4,0-51.7C27,1.3,47.1,0,61.4,10.3 c0.7,0.5,0.7,1.4,0.2,2L58.9,15c-2,2-5,2.5-7.6,1.3c-9.8-4.6-21.8-2.9-29.9,5.2c-10.3,10.3-10.3,26.9,0,37.2 c8.1,8.1,20.2,9.8,30,5.1c2.5-1.2,5.4-0.7,7.3,1.2L61.5,67.6z"
  }))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Active"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Reference",
    display: "none"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteavicon);
export default __webpack_public_path__ + "static/media/carteavicon.3870ff90d07a4a4c5a0afddd86cb2dda.svg";
export { ForwardRef as ReactComponent };